export function ForecastingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/forecasting.svg'"></ng-include>`
    }
}